module.exports = __webpack_public_path__ + "static/media/estilo2.39e535fe.png";